import overview from '@/assets/student-showcase/overview.webp.asset.json';
import skills from '@/assets/student-showcase/skills.webp.asset.json';
import history from '@/assets/student-showcase/history.webp.asset.json';
import './StudentAppShowcase.css';

const screens = [
  {
    asset: overview,
    title: 'Your progress overview',
    description: 'See your driving progress and current test-readiness indicator together.',
    alt: 'Illustrative learner dashboard showing 33% skills progress and 60% test readiness, calculated from anonymous example scores.',
  },
  {
    asset: skills,
    title: 'Your DVSA driving skills',
    description: 'Follow the 27 driving skills and see which areas we’re developing together.',
    alt: 'Illustrative DVSA Skills screen showing overall progress and tracking for Cockpit drill and Controls.',
  },
  {
    asset: history,
    title: 'Your lesson reviews',
    description: 'Revisit what went well, what to practise and the focus for your next lesson.',
    alt: 'Illustrative two-hour lesson review with example mirror-check feedback and next-lesson focus.',
  },
];

export default function StudentAppShowcase() {
  return (
    <section id="student-app" aria-labelledby="student-app-title" aria-describedby="student-app-example" className="student-app-showcase px-5 py-12 sm:py-20 border-y border-border">
      <div className="mx-auto max-w-5xl">
        <div className="mx-auto max-w-2xl text-center mb-12">
          <p className="text-sm font-semibold text-primary mb-2">Included with every learner</p>
          <h2 id="student-app-title" className="text-2xl sm:text-4xl font-bold text-foreground mb-3">Your progress, between lessons</h2>
          <p className="text-base text-muted-foreground leading-relaxed">Your Best-Drive student app keeps your learning in one place, so you and I can see what’s improving and what to work on next.</p>
          <p id="student-app-example" className="text-xs text-muted-foreground leading-relaxed mt-4">Actual learner app screens with illustrative, anonymous example data. The percentages are examples, not pupil results or a prediction of passing.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 items-start">
          {screens.map((screen, index) => (
            <figure key={screen.title} className={`w-full max-w-[290px] mx-auto ${index === 1 ? 'md:pt-8 max-md:translate-x-2' : 'max-md:-translate-x-2'}`}>
              <div className="learner-phone">
                <img src={screen.asset.url} alt={screen.alt} width={1170} height={2280} loading="lazy" decoding="async" className="block w-full h-auto rounded-[24px]" />
              </div>
              <figcaption className="mt-6 text-center">
                <span className="text-xs font-semibold text-primary">0{index + 1}</span>
                <h3 className="mt-1 mb-2 text-lg font-semibold text-foreground">{screen.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{screen.description}</p>
              </figcaption>
            </figure>
          ))}
        </div>
        <p className="mx-auto max-w-xl mt-12 text-center text-sm text-muted-foreground leading-relaxed">Progress is individual. Your readiness indicator helps guide practice — it doesn’t guarantee a test pass.</p>
      </div>
    </section>
  );
}